<template>
  <div class="loader" v-if="loading" />
  <div class="picker-root" v-else>
    <div style="flex:1">
      <div class="header">
        <i class="far fa-arrow-alt-circle-left" @click="prevMonth"></i>
        <div class="header-date">{{ selectedMonth + ' ' + currentYear }}</div>
        <i class="far fa-arrow-alt-circle-right" @click="nextMonth"></i>
      </div>
      <div class="week header">
        <div
          class="day-header"
          v-for="(staticDay, index) in staticDays"
          :key="index"
        >
          {{ staticDay }}
        </div>
      </div>
      <div class="month">
        <div class="week" v-for="(week, index) in weeks" :key="index">
          <div
            :class="dayClass(day)"
            v-for="(day, index) in week"
            :key="index"
            @click="selectDay(day)"
          >
            <div class="day-number" :class="day.isToday ? 'today' : ''">
              {{ day.num }}
            </div>
            <template v-if="hasEvent(day)">
              <div class="day-event" v-for="(ev, i) in eventName(day)" :key="i">
                {{ ev }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../../digilib_web/core/digitify';
import BaseCalendar from './base_calendar';

export default {
  extends: BaseCalendar,
  props: {
    profile: Object,
    selectedDays: Array,
    enableWeekends: Boolean,
    enableEvents: Boolean
  },
  data() {
    return {
      selectedCounter: 0
    };
  },
  mounted() {
    // reset current if there's selected days
    if (this.selectedDays.length > 0) {
      this.selectedCounter = this.selectedDays.length === 1 ? 1 : 2;
      this.current = this.dayjs(this.selectedDays[0]).date(1);
      this.refresh();
    }
  },
  watch: {
    currentYear(n) {
      this.reloadEvents();
    }
  },
  methods: {
    reloadEvents() {
      this.loading = true;
      let year = this.currentYear;
      this.events = [];
      http.get(`calendars/${year}`).then(json => {
        this.events = json.data;
        if (this.profile) {
          let endpoint = `employees/timeoffs/annually/${year}?where=id_employee,=,${
            this.profile.id
          }`;
          // load the timeoffs of the employee annually
          http.get(endpoint).then(json => {
            json.data.forEach(elem => {
              elem.dates.forEach(date => {
                // add the events
                let status =
                  elem.is_approved === null
                    ? 'Pending'
                    : elem.is_approved
                    ? 'Approved'
                    : 'Rejected';
                let evName = `${elem.type} (${status})`;
                let ev = { date: date, name: evName };
                this.events.push(ev);
              });
            });
            // the page is ready
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
    nextMonth() {
      this.$emit('update:selectedDays', []);
      this.selectedCounter = 0;
      this.setNextMonth();
    },
    prevMonth() {
      this.$emit('update:selectedDays', []);
      this.selectedCounter = 0;
      this.setPrevMonth();
    },
    unselectable(day) {
      if (this.enableWeekends && !this.enableEvents) {
        return this.hasEvent(day);
      } else if (this.enableEvents) {
        if (this.enableWeekends) {
          return false;
        } else {
          return day.state.includes('other');
        }
      }
      return day.state.includes('other') || this.hasEvent(day);
    },
    eventName(day) {
      let evs = [];
      this.events.forEach(x => {
        if (x.date === day.formatted) {
          evs.push(x.name);
        }
      });
      return evs;
    },
    dayClass(day) {
      // might want to refactor this later
      let selected = this.selectedDays.find(x => x === day.formatted)
        ? 'selected'
        : '';
      return `${day.state} ${selected} ${this.hasEvent(day) ? 'other' : ''}`;
    },
    selectDay(day) {
      if (this.unselectable(day)) {
        return;
      }
      // make a clone of the selected days prop
      let temp = this.selectedDays.slice();
      // if there's nothing selected yet, set selected
      if (this.selectedCounter === 0) {
        this.selectedCounter++;
        temp.push(day.formatted);
      } else if (this.selectedCounter === 1) {
        // if there's one selected already, select the range from beginning to the end
        this.selectedCounter++;
        temp.push(day.formatted);
        let days = this.days;
        // get the start and end idx
        let startIdx = days.indexOf(days.find(x => x.formatted === temp[0]));
        let endIdx = days.indexOf(day);
        // swap the index if the end is smaller than start
        if (endIdx < startIdx) {
          let tempIdx = startIdx;
          startIdx = endIdx;
          endIdx = tempIdx;
        }
        // set selected
        temp = [];
        for (let i = startIdx; i <= endIdx; ++i) {
          if (this.unselectable(days[i])) {
            continue;
          }
          temp.push(days[i].formatted);
        }
      } else {
        // if there are 2 selecteds, just do select the one currently gets clicked
        this.selectedCounter = 1;
        temp = [];
        temp.push(day.formatted);
      }
      this.$emit('update:selectedDays', temp);
    }
  }
};
</script>

<style scoped>
.picker-root {
  display: -webkit-flex;
  display: flex;
  border: 0.5px solid rgba(160, 159, 160, 0.4);
  border-radius: 5px;
  overflow: hidden;
  flex: 1 1 auto;
}
.header {
  padding: 5px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.header > i {
  font-size: 24px;
  cursor: pointer;
}
.header-date {
  font-size: 1.1em;
  line-height: 2em;
}
.week {
  display: -webkit-flex;
  display: flex;
}
.week.header {
  border: 0.5px solid #dedede;
  border-width: 1px 0 1px 0;
}
.day,
.day-header {
  flex: 1;
  text-align: center;
}
.day-header {
  color: rgba(160, 159, 160, 1);
}
.day {
  cursor: pointer;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid rgba(160, 159, 160, 0.2);
  height: 65px;
  padding: 5px;
}
.day.other {
  color: #bdc3c7;
}
.day.selected {
  background-color: rgba(98, 183, 166, 0.3);
}
.day-number {
  font-size: 0.85em;
  letter-spacing: 1.5px;
  width: 20px;
  height: 20px;
}
.day-number.today {
  color: white;
  border-radius: 20px;
  background: #62b7a6;
}
.day-event {
  font-size: 0.8em;
  color: black;
}
@media all and (max-width: 640px) {
  .picker-root {
    flex-flow: column;
    max-height: 600px;
  }
  .day-event {
    display: none;
  }
}
</style>
